import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Colors, Languages } from '../../../common';

const PaymentTab = ({ onChange }) => {
    const [activeTab, setActiveTab] = useState('method'); // Updated state management

    // Handle tab change
    const handleTabChange = (tab) => {
        setActiveTab(tab);
        if (tab === 'method') {
            onChange(Languages.PaymentMethod);
        } else if (tab === 'history') {
            onChange(Languages.TransactionHistory);
        } else if (tab === 'autoRecharge') {
            onChange(Languages.EnableAutoRenew); // Ensure this language key exists
        }
    };

    return (
        <Box 
            className='tabBoxShadow'
            sx={{
                display: 'flex',
                flexDirection: 'row',
                backgroundColor: Colors.Secondary,
            }}
        >
            <Box 
                sx={{
                    borderRadius: 2,
                    height: 48,
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: activeTab === 'method' ? Colors.Primary : Colors.Secondary,
                }}
            >
                <Button
                    style={{
                        height: 48,
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                        fontWeight: activeTab === 'method' ? 'bold' : 'normal',
                        fontSize: 11,
                        color: activeTab === 'method' ? Colors.White : Colors.Black,
                        alignItems: 'center',
                    }}
                    onClick={() => handleTabChange('method')}
                >
                    {Languages.PaymentMethod}
                </Button>
            </Box>
            <Box 
                sx={{
                    borderRadius: 2,
                    height: 48,
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: activeTab === 'history' ? Colors.Primary : Colors.Secondary,
                }}
            >
                <Button
                    style={{
                        height: 48,
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                        fontWeight: activeTab === 'history' ? 'bold' : 'normal',
                        fontSize: 11,
                        color: activeTab === 'history' ? Colors.White : Colors.Black,
                        alignItems: 'center',
                    }}
                    onClick={() => handleTabChange('history')}
                >
                    {Languages.TransactionHistory}
                </Button>
            </Box>
            <Box 
                sx={{
                    borderRadius: 2,
                    height: 48,
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: activeTab === 'autoRecharge' ? Colors.Primary : Colors.Secondary,
                }}
            >
                <Button
                    style={{
                        height: 48,
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                        fontWeight: activeTab === 'autoRecharge' ? 'bold' : 'normal',
                        fontSize: 11,
                        color: activeTab === 'autoRecharge' ? Colors.White : Colors.Black,
                        alignItems: 'center',
                    }}
                    onClick={() => handleTabChange('autoRecharge')}
                >
                    {Languages.EnableAutoRenew} 
                </Button>
            </Box>
        </Box>
    );
};

export default PaymentTab;
